module.exports = __webpack_public_path__ + "static/media/appointment-calender.38eded46.svg";